export default "__VITE_ASSET__60b4321f__"